/**
 * 选择插件：注册 SelectionService 服务，依赖 PickingService
 */

import { DUAL_BACKEND_GRAPHICS_REQUIREMENTS } from '@/graphics/GraphicsRequirements'
import type { EngineContext } from '@/runtime/EngineContext'
import type { Plugin } from '@/shared/types/plugin'
import { SelectionServiceImpl } from './SelectionService'

/** 选择插件：在 onInit 中注册 SelectionService，声明依赖 PickingService */
export class SelectionPlugin implements Plugin {
  /** 插件名称 */
  readonly name = 'selection'
  readonly graphicsRequirements = DUAL_BACKEND_GRAPHICS_REQUIREMENTS
  /** 插件启动优先级 */
  readonly priority = 30
  /** 依赖的服务名列表 */
  readonly dependencies = ['PickingService'] as const
  /** 对外提供的服务名列表 */
  readonly provides = ['SelectionService'] as const

  /** 选择服务实例 */
  private service: SelectionServiceImpl | null = null
  /** 避免重复销毁 */
  private _disposed = false

  /**
   * 初始化插件，注册 SelectionService。
   *
   * @param context - 引擎上下文
   */
  onInit(context: EngineContext): void {
    this._disposed = false
    this.service = new SelectionServiceImpl(context.events)
    context.registerService('SelectionService', this.service)
  }

  /** 启动插件占位 */
  onStart(): void {}

  /** 销毁插件，释放 service */
  onDestroy(): void {
    if (this._disposed) return
    this._disposed = true
    this.service?.dispose()
    this.service = null
  }
}
